import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface ReactivatePlansPayload {
  planIds: string[];
}

const usePlansReactivation = () => {
  const { mutateAsync } = useMutation((payload: ReactivatePlansPayload) => 
    api.post(API_URL.PLANS_REACTIVATION, payload)
  );

  const handleReactivate = async (payload: ReactivatePlansPayload) => {
    const response = await mutateAsync(payload);
    return response?.data;
  };

  return handleReactivate;
};

export default usePlansReactivation;
